import React from "react";
import EntityListPage, { StatusBadge, Money } from "@/components/EntityListPage";
import { Badge } from "@/components/ui/badge";

const FIELDS = [
    { key: "sku", label: "SKU", required: true, placeholder: "e.g. YT-1024" },
    { key: "name", label: "Product name", required: true, full: false },
    { key: "brand", label: "Brand" },
    { key: "category", label: "Category" },
    {
        key: "unit",
        label: "Unit",
        type: "select",
        default: "pcs",
        options: [
            { value: "pcs", label: "Pieces" },
            { value: "box", label: "Box" },
            { value: "kg", label: "Kg" },
            { value: "ltr", label: "Litre" },
            { value: "mtr", label: "Metre" },
            { value: "dozen", label: "Dozen" },
        ],
    },
    { key: "hsn_code", label: "HSN code" },
    { key: "tax_rate", label: "Tax % (GST)", type: "number", default: 0 },
    { key: "cost_price", label: "Cost price (₹)", type: "number", default: 0 },
    { key: "wholesale_price", label: "Wholesale price (₹)", type: "number", default: 0 },
    { key: "retail_price", label: "Retail price (₹)", type: "number", default: 0 },
    { key: "mrp", label: "MRP (₹)", type: "number", default: 0 },
    { key: "tags", label: "Tags (comma separated)", type: "tags", full: true },
    { key: "description", label: "Description", type: "textarea", full: true },
    { key: "is_active", label: "Active", type: "boolean", default: true },
];

const COLUMNS = [
    {
        key: "sku",
        label: "SKU",
        render: (r) => <span className="font-mono text-xs text-zinc-700">{r.sku}</span>,
    },
    {
        key: "name",
        label: "Product",
        render: (r) => (
            <div>
                <div className="text-sm font-medium text-zinc-900">{r.name}</div>
                {r.brand && <div className="text-xs text-zinc-500">{r.brand}</div>}
            </div>
        ),
    },
    {
        key: "category",
        label: "Category",
        render: (r) =>
            r.category ? (
                <Badge variant="secondary" className="text-[10px] uppercase tracking-widest">
                    {r.category}
                </Badge>
            ) : (
                "—"
            ),
    },
    { key: "unit", label: "Unit", render: (r) => <span className="text-xs text-zinc-600">{r.unit}</span> },
    { key: "cost_price", label: "Cost", align: "right", render: (r) => <Money value={r.cost_price} /> },
    {
        key: "wholesale_price",
        label: "Wholesale",
        align: "right",
        render: (r) => <Money value={r.wholesale_price} />,
    },
    { key: "retail_price", label: "Retail", align: "right", render: (r) => <Money value={r.retail_price} /> },
    { key: "is_active", label: "Status", render: (r) => <StatusBadge active={r.is_active} /> },
];

export default function ProductBrain() {
    return (
        <EntityListPage
            testId="page-product-brain"
            title="Product Brain"
            description="A unified intelligence layer for every SKU — pricing, margins, and movement."
            resourcePath="/products"
            fields={FIELDS}
            columns={COLUMNS}
            addLabel="Add product"
            emptyLabel="No products yet. Add your first SKU."
        />
    );
}
